/* Vearo – policy pages: turn the plain-text policy copy into real headings and lists. */
(function () {
  var container = document.querySelector('.shopify-policy__container');
  if (!container) return;

  var titleWrap = container.querySelector('.shopify-policy__title');
  var body = container.querySelector('.shopify-policy__body .rte') || container.querySelector('.shopify-policy__body');
  if (!titleWrap || !body) return;

  var BULLET = /^\s*[*•·–-]\s+/;
  var NUMBERED = /^(\d+(?:\.\d+)*)[.)]\s+(\S.*)$/;
  var paragraphs = Array.prototype.slice.call(body.querySelectorAll('p')).filter(function (p) {
    return !p.closest('li, td, th, blockquote');
  });
  var titleFound = false;
  var leadFound = false;

  paragraphs.forEach(function (p, index) {
    var text = p.textContent.replace(/\s+/g, ' ').trim();
    if (!text) {
      p.remove();
      return;
    }

    // Leading line that just repeats the page title
    if (!titleFound && index < 3 && text.length < 60 && !/[.:;]$/.test(text) && /policy|terms/i.test(text)) {
      var h1 = titleWrap.querySelector('h1');
      if (h1) h1.textContent = text;
      titleFound = true;
      p.remove();
      return;
    }

    if (/^last updated/i.test(text) && text.length < 60) {
      p.className = 'vearo-policy__meta';
      titleWrap.appendChild(p);
      return;
    }

    if (!leadFound) {
      leadFound = true;
      if (!NUMBERED.test(text)) p.classList.add('vearo-policy__lead');
    }

    // Only restructure paragraphs made of plain text and line breaks
    if (p.querySelector(':not(br)')) return;

    var lines = p.innerHTML
      .split(/<br\s*\/?>/i)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);

    var hasBullets = lines.some(function (line) {
      return BULLET.test(line);
    });

    if (hasBullets) {
      var fragment = document.createDocumentFragment();
      var list = null;
      lines.forEach(function (line) {
        if (BULLET.test(line)) {
          if (!list) {
            list = document.createElement('ul');
            fragment.appendChild(list);
          }
          var li = document.createElement('li');
          li.innerHTML = line.replace(BULLET, '');
          list.appendChild(li);
        } else {
          list = null;
          var para = document.createElement('p');
          para.innerHTML = line;
          fragment.appendChild(para);
        }
      });
      p.replaceWith(fragment);
      return;
    }

    var match = lines.length === 1 && text.length < 90 && !/[.;:,]$/.test(text) ? text.match(NUMBERED) : null;
    if (match) {
      var heading = document.createElement('h2');
      heading.className = 'vearo-policy__heading';
      var num = document.createElement('span');
      num.className = 'vearo-policy__num';
      num.textContent = match[1].length === 1 ? '0' + match[1] : match[1];
      var label = document.createElement('span');
      label.textContent = match[2];
      heading.appendChild(num);
      heading.appendChild(label);
      p.replaceWith(heading);
    }
  });
})();
